import { httpClient } from "@/app/old/desktop/shared/services/";
import { coreBaseUrl } from "@/environment/environment";

class API {
  constructor() {
    this.baseURL = coreBaseUrl;
  }

  async generate_url(req) {
    return httpClient({
      url: `generateurl/`,
      baseURL: this.baseURL,
      headers: req.headers,
      method: "post",
      data: req.body,
    }).then(res => res.data);
  }
}

export const iconService = new API();
